<template>
  <grid ref="myGrid" :gridConfigUrl="gridConfigUrl">
    <template slot="lastHeaderColumns" slot-scope="props">
      <grid-table-th
        v-if="props.magicalMenuCodes.includes('usageRecord')"
        width="80px"
      >使用记录
      </grid-table-th>
      <grid-table-th
        v-if="props.magicalMenuCodes.includes('serviceConfig')"
        width="80px"
      >服务配置
      </grid-table-th>
    </template>
    <template slot="lastBodyColumns" slot-scope="props">
      <grid-table-td
        v-if="props.magicalMenuCodes.includes('usageRecord')"
        @click.native="handle(props.row, 'usageRecord')"
        width="80px"
      >使用记录
      </grid-table-td>
      <grid-table-td
        v-if="props.magicalMenuCodes.includes('serviceConfig')"
        @click.native="handle(props.row, 'serviceConfig')"
        width="80px"
      >服务配置
      </grid-table-td>
    </template>
  </grid>
</template>
<script>
import Grid from '../../../components/grid/grid.vue'
import GridTableTh from '../../../components/grid-menu/grid-table-th'
import GridTableTd from '../../../components/grid-menu/grid-table-td'
import GridTopMenu from '../../../components/grid-menu/grid-top-menu'
import util from '../../../libs/util'

export default {
  components: {
    GridTopMenu,
    GridTableTd,
    GridTableTh,
    Grid
  },
  name: 'to-service-record',
  data() {
    return {
      gridConfigUrl: ''
    }
  },
  created() {
    this.gridConfigUrl = this.$route.meta.url
  },
  methods: {
    handle(data, columnType) {
      const config = this.resolveColumConfig(columnType)
      if (config == null) {
        return
      }
      const routerName = data.code + config.routerSuffix
      if (this.$router.resolve({name: routerName}).resolved.matched.length > 0) {
        util.changeRouter(this, {
          name: routerName
        })
      } else {
        this.showNotify({title: data.name, message: config.errMsg}, config.notifyType)
      }
    },
    resolveColumConfig(columnType) {
      switch (columnType) {
        case 'usageRecord':
          return {routerSuffix: '-usage-record', errMsg: '该服务的使用记录暂未提供', notifyType: 'error'}
        case 'serviceConfig':
          return {routerSuffix: '-service-config', errMsg: '该服务无需配置', notifyType: 'info'}
        default:
          return null
      }
    },
    showNotify(data, type) {
      switch (type) {
        case 'error':
          this.$notify.error(data)
          break
        case 'warn':
          this.$notify.warning(data)
          break
        case 'info':
          this.$notify.info(data)
          break
        case 'success':
          this.$notify.success(data)
          break
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/custom/components/grid/to-service-record.vue